import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './order-cancel.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { OrderCancel } from "model/procure/order-cancel.model";

export interface OrderCancelDetailsProps extends DetailsStateAndDispatchProps<OrderCancel>,
  RouteComponentProps, StateProps, DispatchProps {
}
const OrderCancelDetails: FC<OrderCancelDetailsProps> = (props) => {
  return (
    <DetailsPage<OrderCancel>
      title={'订单取消原因'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<OrderCancel>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ orderCancel }: RootState) => ({
  entity: orderCancel.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(OrderCancelDetails);
